<template>
  <transition name="toast">
    <div v-if="show" class="custom-toast" :class="type">
      <div class="toast-message">{{ message }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CustomToast",
  props: {
    show: Boolean,
    message: String,
    type: {
      type: String,
      default: "success",
      validator: (value) => ["success", "error", "info"].includes(value),
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        // 2秒后自动隐藏
        setTimeout(() => {
          this.$emit("update:show", false);
        }, 2000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-toast {
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.2rem 0.4rem;
  border-radius: 0.16rem;
  display: flex;
  align-items: center;
  z-index: 2200;
  box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.15);

  &.success {
    background-color: #25c773;
    color: white;
  }

  &.error {
    background-color: #e0293e;
    color: white;
  }
  &.info {
    background-color: #4f96ff;
    color: white;
  }

  .toast-message {
    font-size: 0.28rem;
    font-weight: 500;
    text-align: center;
  }
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
